/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
const Toaster = (props: any) => {
    return (
        <>
            <div
                style={{
                    minWidth: '250px',
                    backgroundColor: props.type === 'success' ? '#79a22e' : '#dc3545',
                    color: '#fff',
                    textAlign: 'center',
                    borderRadius: '10px',
                    padding: '16px',
                    position: 'fixed',
                    zIndex: 1,
                    left: '80%',
                    bottom: '30px',
                    animation: 'fadein 0.5s, fadeout 0.5s 2.5s'
                }}
            >
                {props.message}
            </div>
        </>
    );
};

export default Toaster;
